export const hasRequiredPermissions = (
  rolesUser: string[],
  permissionsArea: string[],
): boolean => {
  return rolesUser?.some((permission) => permissionsArea.includes(permission));
};
